((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.CorkopiaCartSummary = api;
})(typeof globalThis !== 'undefined' ? globalThis : window, () => {
  'use strict';

  const finite = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;

  const summarize = (cart = {}) => {
    const items = Array.isArray(cart.items) ? cart.items : [];
    const itemCount = Number.isFinite(Number(cart.item_count))
      ? Number(cart.item_count)
      : items.reduce((total, item) => total + finite(item.quantity), 0);
    const subtotalCents = Number.isFinite(Number(cart.total_price))
      ? Number(cart.total_price)
      : items.reduce((total, item) => total + finite(item.final_line_price), 0);
    return { itemCount, subtotalCents };
  };

  const formatMoney = (cents = 0, currency = 'USD', locale) => {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(finite(cents) / 100);
    } catch {
      return `${(finite(cents) / 100).toFixed(2)} ${currency}`;
    }
  };

  const render = (root, cart, currency = 'USD') => {
    const summary = summarize(cart);
    const label = summary.itemCount === 1 ? 'item' : 'items';
    root.querySelectorAll('[data-cart-item-count]').forEach((element) => { element.textContent = String(summary.itemCount); });
    root.querySelectorAll('[data-cart-item-label]').forEach((element) => { element.textContent = label; });
    root.querySelectorAll('[data-cart-subtotal]').forEach((element) => { element.textContent = formatMoney(summary.subtotalCents, currency); });
    root.querySelectorAll('[data-cart-summary-label]').forEach((element) => {
      element.setAttribute('aria-label', `Your box, ${summary.itemCount} ${label}, ${formatMoney(summary.subtotalCents, currency)}`);
    });
    return summary;
  };

  return { formatMoney, render, summarize };
});
